import type { FaireProductEntity } from "../../entity_types/product";

export const p_95qpz99q5v: FaireProductEntity = {
  token: "p_95qpz99q5v",
  type: "product",
  name: "Sleep Blend- Vegan 30 Capsules",
  brandToken: "b_suq5c39heq",
  brandName: "Magik Roots",
  imageUrl:
    "https://cdn.faire.com/fastly/4d3f3d45fa059bb0c3d81448687b5805abaa923856f8b1fe60c70fde738f6a79.jpeg",
  galleryImageUrls: [],
  priceDollars: 8,
  description:
    "Pure Sleep Organic Blend - helping to naturally produce the ability to rest and unwind, by boosting calming neurotransmitters like GABA, improving overall sleep quality, decreasing anxious feelings, and tension.\n\nValerian Root – studies suggest this compound lowers brain activity, which may help you relax and sleep better. It may also be a more attractive option than other sleeping agents because of the lack of hangover effect and without known side effects. \n\nPassionflower – Many studies suggest it may help relieve anxiety and insomnia as a dietary supplement for sleep problems, boosting the level of gamma-aminobutyric acid (GABA). GABA lowers the activity of some brain cells, making you feel more relaxed. \n\nChamomile – Traditionally, chamomile has been used to treat insomnia and to induce sedation (calming effects). It is widely regarded as a mild tranquilizer and sleep-inducer. Its anti-inflammatory properties soothe cold symptoms, are good for your heart, can help with digestion, reduce anxiety, soothe sore throats, are good for your immune system reduces muscle spasms, period pain, and much more.",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:49.983Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
